import { PlayPeriod } from '../../core/models/play-period.model';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
})
export class CountdownComponent implements OnInit, OnDestroy {
  @Input()
  public playPeriod!: PlayPeriod;

  timer = 0;
  days = 0
  hours = 0
  minutes = 0
  seconds = 0
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private interval: any;

  ngOnInit(): void {
    console.log(this.playPeriod)
    if (this.playPeriod) {
      this.timer = Math.max(
        Math.floor(
          (new Date(this.playPeriod.endDate).getTime() - new Date().getTime()) /
          1000
        ),
        0
      );
      this.startCountdown();
    }
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startCountdown(): void {
    this.updateTimeUnits();
    this.interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
        this.updateTimeUnits();
      } else {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  updateTimeUnits(): void {
    this.days = Math.floor(this.timer / (3600 * 24));
    this.hours = Math.floor((this.timer % (3600 * 24)) / 3600);
    this.minutes = Math.floor((this.timer % 3600) / 60);
    this.seconds = this.timer % 60;
  }


}
